import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes'); 
export const SettingModule = lazy(loadModule);

export default SettingModule;




